const getCapRepRedesignBaselineDocIdKey = (prospectId: string) =>
  `cap-rep-redesign-baseline-doc-id-${prospectId}`;

const getCapRepRedesignReadyToPollKey = (prospectId: string) =>
  `cap-rep-redesign-ready-to-poll-${prospectId}`;

const getCapRepRedesignBaselineDocId = (prospectId: string): string | null => {
  if (typeof sessionStorage === "undefined" || !prospectId) {
    return null;
  }
  return sessionStorage.getItem(getCapRepRedesignBaselineDocIdKey(prospectId));
};

const setCapRepRedesignBaselineDocId = (
  prospectId: string,
  documentId: string
): void => {
  if (typeof sessionStorage === "undefined" || !prospectId) {
    return;
  }
  sessionStorage.setItem(
    getCapRepRedesignBaselineDocIdKey(prospectId),
    documentId
  );
  sessionStorage.removeItem(getCapRepRedesignReadyToPollKey(prospectId));
};

const isCapRepRedesignReadyToPoll = (prospectId: string): boolean => {
  if (typeof sessionStorage === "undefined" || !prospectId) {
    return false;
  }
  return (
    sessionStorage.getItem(getCapRepRedesignReadyToPollKey(prospectId)) ===
    "true"
  );
};

const setCapRepRedesignReadyToPoll = (prospectId: string): void => {
  if (typeof sessionStorage === "undefined" || !prospectId) {
    return;
  }
  sessionStorage.setItem(getCapRepRedesignReadyToPollKey(prospectId), "true");
};

const clearCapRepRedesignDocRefreshState = (prospectId: string): void => {
  if (typeof sessionStorage === "undefined" || !prospectId) {
    return;
  }
  sessionStorage.removeItem(getCapRepRedesignBaselineDocIdKey(prospectId));
  sessionStorage.removeItem(getCapRepRedesignReadyToPollKey(prospectId));
};

const shouldPollForRepRedesignCapDocs = (prospectId: string): boolean => {
  return (
    !!getCapRepRedesignBaselineDocId(prospectId) &&
    isCapRepRedesignReadyToPoll(prospectId)
  );
};

export {
  clearCapRepRedesignDocRefreshState,
  getCapRepRedesignBaselineDocId,
  getCapRepRedesignBaselineDocIdKey,
  getCapRepRedesignReadyToPollKey,
  isCapRepRedesignReadyToPoll,
  setCapRepRedesignBaselineDocId,
  setCapRepRedesignReadyToPoll,
  shouldPollForRepRedesignCapDocs,
};
